<mat-card class="cprng-endpoints-card">
  <mat-card-header>
    <mat-card-title>API-endpoints (CPRNG audit)</mat-card-title>
    <mat-card-subtitle>
      Sorteret efter adgangsniveau. Misconfigured:
      {{ misconfiguredCount }}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    @if (loading) {
      <mat-progress-bar mode="indeterminate" />
    }

    @if (errorMessage) {
      <p class="error">{{ errorMessage }}</p>
    }

    <div class="toolbar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Søg path / handler</mat-label>
        <input
          matInput
          [(ngModel)]="search"
          (ngModelChange)="onSearchChange()"
        />
      </mat-form-field>

      <div class="tier-filters">
        <button
          mat-stroked-button
          [class.active]="tierFilter === 'all'"
          (click)="setTierFilter('all')"
        >
          Alle
        </button>
        @for (tier of tierOptions; track tier) {
          <button
            mat-stroked-button
            [class]="tierClass(tier)"
            [class.active]="tierFilter === tier"
            (click)="setTierFilter(tier)"
          >
            {{ tierLabels[tier] }}
          </button>
        }
      </div>

      <button mat-icon-button type="button" (click)="load()" matTooltip="Genindlæs">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <table mat-table [dataSource]="tableDataSource" class="endpoints-table">
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef>Method</th>
        <td mat-cell *matCellDef="let row">{{ row.method }}</td>
      </ng-container>

      <ng-container matColumnDef="path">
        <th mat-header-cell *matHeaderCellDef>Path</th>
        <td mat-cell *matCellDef="let row" class="path-cell">{{ row.path }}</td>
      </ng-container>

      <ng-container matColumnDef="access_tier">
        <th mat-header-cell *matHeaderCellDef>Tier</th>
        <td mat-cell *matCellDef="let row">
          <span [class]="'tier-badge ' + tierClass(row.access_tier)">
            {{ tierLabel(row.access_tier) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>Roller</th>
        <td mat-cell *matCellDef="let row">
          @if (row.roles?.length) {
            <mat-chip-set>
              @for (role of row.roles; track role) {
                <mat-chip>{{ role }}</mat-chip>
              }
            </mat-chip-set>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="groups">
        <th mat-header-cell *matHeaderCellDef>Grupper</th>
        <td mat-cell *matCellDef="let row">
          @if (row.groups?.length) {
            <mat-chip-set>
              @for (group of row.groups; track group) {
                <mat-chip>{{ group }}</mat-chip>
              }
            </mat-chip-set>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="requires_login">
        <th mat-header-cell *matHeaderCellDef>requires_login</th>
        <td mat-cell *matCellDef="let row">{{ row.requires_login }}</td>
      </ng-container>

      <ng-container matColumnDef="handler">
        <th mat-header-cell *matHeaderCellDef>Handler</th>
        <td mat-cell *matCellDef="let row" class="handler-cell">
          {{ row.handler }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.row-misconfigured]="row.access_tier === 'misconfigured'"
      ></tr>
    </table>

    <mat-paginator
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [hidePageSize]="true"
      showFirstLastButtons
      aria-label="Vælg side med endpoints"
    />
  </mat-card-content>
</mat-card>
